// extracted by mini-css-extract-plugin
export default {"feed":"profile-feed_feed__Maf+f","orders":"profile-feed_orders__xaRlJ","order":"profile-feed_order__9Xm-M","info":"profile-feed_info__8Cc+3","status":"profile-feed_status__fJhMZ"};